import { Injectable, inject } from "@angular/core";
import { ErrorService } from "@app/common/services/error.service";
import { IItemDto } from "@app/shared/models/dtos/item";
import { IItemCategoryDto } from "@app/shared/models/dtos/item-category";
import { IItemScopingCategoryDto } from "@app/shared/models/dtos/item-scoping-category";
import { IItemSubCategoryDto } from "@app/shared/models/dtos/item-sub-category";
import { IProjectSubTypeDto } from "@app/shared/models/dtos/project-subtype";
import { BehaviorSubject, Observable } from "rxjs";
import { ItemManagementService } from "../services/item-management.service";
import { LookupService } from "../services/lookup.service";

@Injectable({
  providedIn: 'root'
})
export class ScopingItemsSharedService {
  private itemManagementService = inject(ItemManagementService);
  private errorService = inject(ErrorService);
  private lookupService = inject(LookupService);

  public IItemCategoryDtos: Array<IItemCategoryDto> = new Array<IItemCategoryDto>();
  public IItemSubCategoryDtos: Array<IItemSubCategoryDto> = new Array<IItemSubCategoryDto>();
  public IItemScopingCategoryDtos: Array<IItemScopingCategoryDto> = new Array<IItemScopingCategoryDto>();
  public IItemDtos: Array<IItemDto> = new Array<IItemDto>();
  public IProjectSubTypeDtos: Array<IProjectSubTypeDto> = new Array<IProjectSubTypeDto>();
  private everythingLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public async loadLookups() {
    try {
      this.IItemCategoryDtos = (await this.itemManagementService.findItemTypeDtos()).Results;
      this.IItemSubCategoryDtos = (await this.itemManagementService.findItemSubTypeDtos()).Results;
      this.IItemScopingCategoryDtos = (await this.itemManagementService.findItemScopingTypeDtos()).Results;
      this.IItemDtos = (await this.itemManagementService.findItemDtos()).Results;
      this.IProjectSubTypeDtos = (await this.lookupService.findProjectSubTypeDtos()).Results;
      this.everythingLoaded$.next(true);
    }
    catch (error) {
      this.errorService.error("Error loading up data.", error);
    }
  }

  public isItemsLoaded(): Observable<boolean> {
    return this.everythingLoaded$;
  }
}